export default __webpack_public_path__ + "static/media/corey-roth-transparent.9af62fe9.png";